import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { Subject, ReplaySubject } from 'rxjs';
import { isNotNull } from '@satin/core/utility';
import * as i2 from '@angular/material/dialog';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { FabConfirmationDialogComponent } from '@fabric/components/confirmation-dialog';
import { CommonModule } from '@angular/common';

class ConfirmPopupService {
    constructor() {
        this.confirmPopupSubject = new Subject();
        this.confirmPopup = this.confirmPopupSubject.asObservable();
        this._confirmPopup = null;
    }
    //if we just want to subscribe
    subscribe(fn) {
        return this.confirmPopup.subscribe(fn);
    }
    openPopup(confirmPopup) {
        this.answer$ = new ReplaySubject(null);
        this._confirmPopup = confirmPopup;
        this.confirmPopupSubject.next(this._confirmPopup);
    }
    close() {
        delete this._confirmPopup;
        this.confirmPopupSubject.next(this._confirmPopup);
    }
    getConfirmation() {
        return this.answer$.asObservable();
    }
    setConfirmation(answer) {
        this.answer$.next(answer);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ConfirmPopupService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ConfirmPopupService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ConfirmPopupService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

class ConfirmPopupComponent {
    constructor(confirmPopupService, dialog) {
        this.confirmPopupService = confirmPopupService;
        this.dialog = dialog;
        this.confirmPopup = null;
    }
    ngOnInit() {
        this.sub = this.confirmPopupService.subscribe((confirmPopup) => {
            this.confirmPopup = confirmPopup;
            if (isNotNull(this.confirmPopup)) {
                this.openConfirmationDialog();
            }
        });
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
    close() {
        this.confirmPopupService.close();
    }
    showConfirmationPopup() {
        return isNotNull(this.confirmPopup);
    }
    yesButtonClick() {
        this.confirmPopupService.setConfirmation(true);
        this.close();
    }
    noButtonClick() {
        this.confirmPopupService.setConfirmation(false);
        this.close();
    }
    openConfirmationDialog() {
        const dialogRef = this.dialog.open(FabConfirmationDialogComponent, {
            width: '500px',
            disableClose: true,
            data: this.confirmPopup
        });
        dialogRef.afterClosed().subscribe((result) => {
            return result ? this.yesButtonClick() : this.noButtonClick();
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ConfirmPopupComponent, deps: [{ token: ConfirmPopupService }, { token: i2.MatDialog }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.10", type: ConfirmPopupComponent, selector: "confirmation-popup", ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ConfirmPopupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'confirmation-popup',
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: ConfirmPopupService }, { type: i2.MatDialog }]; } });

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
class ConfirmPopupModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ConfirmPopupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.10", ngImport: i0, type: ConfirmPopupModule, declarations: [ConfirmPopupComponent], imports: [CommonModule], exports: [ConfirmPopupComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ConfirmPopupModule, providers: [
            ConfirmPopupService,
            { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true, panelClass: 'mat-dialog-default-class' } },
        ], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ConfirmPopupModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ConfirmPopupComponent
                    ],
                    providers: [
                        ConfirmPopupService,
                        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true, panelClass: 'mat-dialog-default-class' } },
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        ConfirmPopupComponent
                    ],
                }]
        }] });

class ConfirmPopup {
    constructor(title, body, showConfirmation) {
        this.title = "";
        this.message = "";
        this.yesLabel = "Yes";
        this.noLabel = "No";
        this.showConfirmation = false;
        this.titleIconClass = "fa fa-warning";
        this.title = title;
        this.message = body;
        this.showConfirmation = showConfirmation;
    }
}

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfirmPopup, ConfirmPopupComponent, ConfirmPopupModule, ConfirmPopupService };
